//
// Achievement tags
//
export default [
  'badges', 'characters', 'celebrities',
  'school', 'workplace',
  'children', 'teenagers', 'adults',
];
